import React, { Component } from 'react';
import Constants from '../../../definitions/constants';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../locales/localesConfig';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import toastr from 'toastr';

import Select from '../common/inputs/select';
import TextBox from '../common/inputs/textBox';
import SelectWithTextBoxInput from '../common/inputs/selectWithTextBoxInput';

const initialObjectState = {
  model_id: "",
  template_id: "defect",
  revision_stage: ""
}

class SupervisorModelsEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toAddObject: JavascriptUtilsTooling.deepCopy(initialObjectState),
      toAddObjectPosition: 0,      
      toEditObjectPosition: null,   
      toEditObject: JavascriptUtilsTooling.deepCopy(initialObjectState)
    };
  }
  
  componentDidUpdate(prevProps, prevState) {
    if(!prevState.showOverlay && this.state.showOverlay) {
      InterfaceTooling.bringObjectEditorInputIntoView();
    }
  }
  
  isValidObject = (object, index) => {
    if(!object.model_id){
      toastr.options = Constants.interface.tostrOptions;
      toastr.error(intl.formatMessage({ id: "userAdmin.emptyFieldsSupervisorModelsError"}));
      return false;
    }
    return true;
  };
    
  handleAddButtonClick = (event) => {
    if(this.editItemInput) {
      this.editItemInput.focus();
    }
  };

  handleCancelAdd = (event) => {
    this.setState({
      showOverlay: false,
      toAddObjectPosition: null,
      toAddObject: JavascriptUtilsTooling.deepCopy(initialObjectState)
    });
  };

  handleChangeAddItem = (event) => {
    let value = JavascriptUtilsTooling.getInputValueFromEvent(event);
    var toAddObject = JavascriptUtilsTooling.deepCopy(this.state.toAddObject);
    if(event.currentTarget.dataset.path == "model_id"){ 
      toAddObject.template_id = "defect";
    }
    toAddObject[event.currentTarget.dataset.path] = value;
    this.setState({
      showOverlay: true,
      toAddObject: toAddObject
    });    
  };

  handleOnEnterAddItem = (event) => {
    if(this.addItemSaveButton) {
      this.addItemSaveButton.click();
    }
  };

  handleSaveAddItem = (event) => {
    if(this.isValidObject(this.state.toAddObject, this.state.toAddObjectPosition)) {
      event.currentTarget.joinSelector = true;
      this.props.onChange(event);
      this.setState({
        showOverlay: false,
        toAddObjectPosition: null,
        toAddObject: JavascriptUtilsTooling.deepCopy(initialObjectState)
      });
    }
  };

  handleClickEdit = (event) => {
    let itemIndex = event.currentTarget.dataset.index;    
    let objectToEdit = JSON.parse(event.currentTarget.dataset.value);
    this.setState({    
      showOverlay: true,  
      toEditObjectPosition: itemIndex,
      toEditObject: objectToEdit
    });
  };

  handleChangeEdit = (event) => {
    let value = JavascriptUtilsTooling.getInputValueFromEvent(event);
    var toEditObject = JavascriptUtilsTooling.deepCopy(this.state.toEditObject);
    if(event.currentTarget.dataset.path == "model_id"){
      toEditObject.template_id= "defect";
    }
    toEditObject[event.currentTarget.dataset.path] = value;
    this.setState({
      toEditObject: toEditObject
    });  
  };

  handleCancelEdit = (event) => {
    this.setState({
      showOverlay: false,
      toEditObjectPosition: null,
      toEditObject: JavascriptUtilsTooling.deepCopy(initialObjectState)
    });
  };

  handleSaveEditItem = (event) => {
    let index = event.currentTarget.dataset.index;
    if(this.isValidObject(this.state.toEditObject, this.state.toEditObjectPosition)) {
      event.currentTarget.joinSelector = true;
      this.props.onChange(event);
      this.setState({
        showOverlay: false,
        toEditObjectPosition: null,
        toEditObject: JavascriptUtilsTooling.deepCopy(initialObjectState)
      });   
    }     
  };

  handleOnEnterEditItem = (event) => {
    if(this.editItemSaveButton) {
      this.editItemSaveButton.click();      
    }   
  };

  handleDeleteItem = (event) => {
    event.currentTarget.joinSelector = true;
    if(this.props.values.length == 1) {
      this.setState({
        toAddObjectPosition: 0,
      });
    }      
    this.props.onChange(event);
  }

  render() {
    const {
      className,
      values,
      onChange,
      modelsList,
      biTemplatesList,
      disabled
    } = this.props;
    const dataPath = this.props["data-path"];    
    let activeModels = [];
    values.forEach((item,i) => {
      if(i!=this.state.toEditObjectPosition){
        activeModels.push(+item.model_id);
      }
    });
    let modelOptions = InterfaceTooling.getSelectArrayFromArrayOfObjects(modelsList, "id", "name", false); 
    modelOptions = modelOptions ? modelOptions.filter(item => !activeModels.includes(item.value) || this.state.toEditObject.model_id == item.value) : [];
    let blockAdd = modelOptions.length > 0 ? false : true;

    return (
      <div className={"custom-input free-text-list select-list object-editor object-template-headers-editor" + (className ? " " + className : "") + " select-list-no-search" + (className ? " " + className : "") + " select-list-no-search" + (this.state.showOverlay ? " free-text-list-overlay" : "")}>
        {this.state.showOverlay && (<div className="free-text-list-overlay-item"></div>)}
        <div className="free-text-list-label">
          <FormattedMessage id="userAdmin.polynomialsSelectTitle"/>
          {(!disabled && !blockAdd)}
        </div>
          <div className="free-text-list-list-wrapper">
            {values && values.map((item,i) => {
              if(this.state.toEditObjectPosition == i) {
                return (
                  <div key={i} className="free-text-list-list-item free-text-list-list-item-edit">
                    <div className="free-text-list-list-item-inner object-editor-inputs">
                      <div className="object-editor-inputs-linebreak"> 
                        <SelectWithTextBoxInput
                          values={this.state.toEditObject.model_id}
                          onClickOption={this.handleChangeEdit}
                          addSelectLocale={ intl.formatMessage({ id: "userAdmin.fields.models_list.model_id" })}
                          options={modelOptions ? modelOptions : []}
                          onClearTextCallback={this.handleChangeEdit}
                          data-path={"model_id"}
                          allowDisplayOptionsButton={true}
                          className="free-text-list-list-edit-item"
                        />
                        <Select 
                          className="free-text-list-list-add-item"
                          value={this.state.toEditObject.template_id}
                          labelLocale={<FormattedMessage id="userAdmin.fields.models_list.template_id"/>}
                          options={(!biTemplatesList || !this.state.toEditObject.model_id) ? [] : 
                            InterfaceTooling.getSelectArrayFromArrayOfObjects(
                              [{"id":"defect", "name": intl.formatMessage({ id: "periodAdmin.exportBiReportsPopup.templateLabelDefect" })}].concat(
                                biTemplatesList.filter(biTemplate => (biTemplate.polynomial_id==this.state.toEditObject.model_id))), 
                              "id", "name", false)}
                          onChange={this.handleChangeEdit}
                          data-path={"template_id"}
                        />
                        <TextBox
                          className="free-text-list-list-edit-item"
                          styleType={Constants.interface.inputs.styleType.OUTLINED}
                          onChange={this.handleChangeEdit}
                          data-path={"revision_stage"}
                          value={this.state.toEditObject.revision_stage}
                          onKeyEsc={this.handleCancelEdit}
                          onKeyEnter={this.handleOnEnterEditItem}
                          type={Constants.interface.inputs.type.TEXT}
                          dataType={Constants.selectKeys.metric.dataType.NUMBER}
                          labelLocale={<FormattedMessage id="userAdmin.fields.models_list.revision_stage"/>}
                        />
                      </div>
                    </div>
                    {(!disabled && this.state.showOverlay) && (
                      <div className="free-text-list-list-item-action-buttons free-text-list-list-item-action-buttons-edit">
                        <i 
                          ref={(input) => { this.editItemSaveButton = input; }}
                          className="fas fa-save"
                          data-index={i}                        
                          data-value={JSON.stringify(this.state.toEditObject)}
                          data-objecteditor={"true"}
                          data-path={dataPath}
                          data-edit={"true"}
                          onClick={this.handleSaveEditItem}                      
                        />         
                        <i className="fas cancel-action fa-times-circle" onClick={this.handleCancelEdit}/>
                      </div>
                    )}
                  </div>
                );
              }
              else {
                let templateFinded = biTemplatesList.find(template => template.id==item.template_id);
                let templateName = templateFinded ? templateFinded.name : intl.formatMessage({id: "common.unknown"});
                templateName = item.template_id == "defect" ? intl.formatMessage({ id: "periodAdmin.exportBiReportsPopup.templateLabelDefect" }) : templateName;
                let modelFinded = modelsList.find(model => model.id==item.model_id);
                let modelName = modelFinded ? modelFinded.name : intl.formatMessage({id: "common.unknown"});
                let stageText = item.revision_stage ? " (" + intl.formatMessage({ id: "userAdmin.fields.models_list.revision_stage_label" }) + item.revision_stage + ")" : "";
                let itemInnerText = modelName + " - " + 
                  intl.formatMessage({ id: "userAdmin.fields.models_list.template_id_label" }) + ": " + templateName +
                  stageText;	
                return (
                  <div key={i} className={"free-text-list-list-item"}>
                    <div title={itemInnerText} className="free-text-list-list-item-inner">
                      {itemInnerText}
                    </div>
                    {!disabled && (
                      <div className="free-text-list-list-item-action-buttons">
                        <i 
                          className="fas fa-edit"
                          onClick={this.handleClickEdit}
                          data-index={i}
                          data-value={JSON.stringify(item)}
                        />
                        <i
                          className="fas delete-action fa-trash"                          
                          data-index={i}
                          data-delete={"true"}
                          data-objecteditor={"true"}
                          data-value={JSON.stringify(item)}
                          data-path={dataPath}
                          onClick={this.handleDeleteItem}
                        />
                      </div>
                    )}
                  </div>
                );
              }
            })}
            <div className="free-text-list-list-item free-text-list-list-item-add">
              <div className="free-text-list-list-item-inner">
                {(!disabled && !blockAdd) && (
                  <div className="object-editor-inputs">                    
                    <div className="object-editor-inputs-linebreak">
                      <SelectWithTextBoxInput
                        values={this.state.toAddObject.model_id}
                        onClickOption={this.handleChangeAddItem}
                        addSelectLocale={ intl.formatMessage({ id: "userAdmin.fields.models_list.model_id" })}
                        options={modelOptions ? modelOptions : []}
                        onClearTextCallback={this.handleChangeAddItem}
                        data-path={"model_id"}
                        allowDisplayOptionsButton={true}
                        className="free-text-list-list-add-item"
                      />
                      <Select 
                        className="free-text-list-list-add-item"
                        value={this.state.toAddObject.template_id}
                        labelLocale={<FormattedMessage id="userAdmin.fields.models_list.template_id"/>}
                        options={(!biTemplatesList || !this.state.toAddObject.model_id) ? [] : 
                          InterfaceTooling.getSelectArrayFromArrayOfObjects(
                            [{"id":"defect", "name": intl.formatMessage({ id: "periodAdmin.exportBiReportsPopup.templateLabelDefect" })}].concat(
                              biTemplatesList.filter(biTemplate => (biTemplate.polynomial_id==this.state.toAddObject.model_id))), 
                            "id", "name", false)}
                        onChange={this.handleChangeAddItem}
                        data-path={"template_id"}
                      />
                      <TextBox
                        className="free-text-list-list-edit-item"
                        styleType={Constants.interface.inputs.styleType.OUTLINED}
                        onChange={this.handleChangeAddItem}
                        data-path={"revision_stage"}
                        value={this.state.toAddObject.revision_stage}
                        onKeyEsc={this.handleCancelAdd}
                        onKeyEnter={this.handleOnEnterAddItem}
                        type={Constants.interface.inputs.type.TEXT}
                        dataType={Constants.selectKeys.metric.dataType.NUMBER}
                        labelLocale={<FormattedMessage id="userAdmin.fields.models_list.revision_stage"/>}
                      />
                    </div>
                  </div>
                )}
              </div>
              {(!disabled && !blockAdd && this.state.showOverlay) ? (
                <div className="free-text-list-list-item-action-buttons free-text-list-list-item-action-buttons-add">
                  <i 
                    ref={(input) => { this.addItemSaveButton = input; }}
                    className="fas fa-save"
                    data-objecteditor={"true"}
                    data-value={JSON.stringify(this.state.toAddObject)}
                    data-path={dataPath}
                    onClick={this.handleSaveAddItem}   
                  />
                  <i 
                    className="fas cancel-action fa-times-circle"
                    onClick={this.handleCancelAdd}
                  />
                </div>
              ) : (!disabled && blockAdd) ? (
                <div className="free-text-list-list-item-inner message" title={intl.formatMessage({id:"metricAdmin.noMoreOptionsModels"})}>
                  {intl.formatMessage({id:"userAdmin.noMoreOptionsModels"})}
                </div>
              ) : null}
            </div>
          </div>
      </div>
    );
  }
}

export default SupervisorModelsEditor;



// WEBPACK FOOTER //
// ./source/client/components/userAdmin/supervisorModelsEditor.jsx